/**@jsx jsx */
import { jsx } from "theme-ui";

interface IconProps {
	fill?: string;
}

// Hamburger Menu Icon
export const Hamburger = ({ fill }: IconProps) => {
	return (
		<svg
			id="hamburger-icon"
			data-name="hamburger-icon"
			xmlns="http://www.w3.org/2000/svg"
			width="27"
			height="20"
			viewBox="0 0 27 20"
			fill={fill}
		>
			<rect
				id="Rectangle_736"
				data-name="Rectangle 736"
				width="27"
				height="3.889"
				rx="1.944"
			/>
			<rect
				id="Rectangle_737"
				data-name="Rectangle 737"
				width="27"
				height="3.889"
				rx="1.944"
				transform="translate(0 8.055)"
			/>
			<rect
				id="Rectangle_738"
				data-name="Rectangle 738"
				width="27"
				height="3.889"
				rx="1.944"
				transform="translate(0 16.111)"
			/>
		</svg>
	);
};

// X or "Times" Icon
export const Times = ({ fill }: IconProps) => {
	return (
		<svg
			id="times-icon"
			data-name="times-icon"
			xmlns="http://www.w3.org/2000/svg"
			width="21.842"
			height="21.842"
			viewBox="0 0 21.842 21.842"
			fill={fill}
		>
			<rect
				id="Rectangle_737"
				data-name="Rectangle 737"
				width="27"
				height="3.889"
				rx="1.944"
				transform="translate(0 19.092) rotate(-45)"
			/>
			<rect
				id="Rectangle_7767"
				data-name="Rectangle 7767"
				width="27"
				height="3.889"
				rx="1.944"
				transform="translate(2.75 0) rotate(45)"
			/>
		</svg>
	);
};

// Location Pin Icon
export const Location = ({ fill }: IconProps) => {
	return (
		<svg
			id="Group_751"
			data-name="Group 751"
			xmlns="http://www.w3.org/2000/svg"
			width="21"
			height="28"
			viewBox="0 0 21 28"
			fill={fill}
		>
			<path
				id="Path_4985"
				data-name="Path 4985"
				d="M58.5,1944A10.512,10.512,0,0,0,48,1954.5c0,7.279,9.478,16.84,9.881,17.244a.875.875,0,0,0,1.237,0c.4-.4,9.881-9.965,9.881-17.244A10.512,10.512,0,0,0,58.5,1944m0,25.86c-2.09-2.236-8.75-9.8-8.75-15.359a8.75,8.75,0,1,1,17.5,0c0,5.555-6.661,13.122-8.75,15.359"
				transform="translate(-48.002 -1944)"
			/>
			<path
				id="Path_4986"
				data-name="Path 4986"
				d="M125.252,2016a5.25,5.25,0,1,0,5.25,5.25,5.256,5.256,0,0,0-5.25-5.25m0,8.75a3.5,3.5,0,1,1,3.5-3.5,3.5,3.5,0,0,1-3.5,3.5"
				transform="translate(-114.752 -2010.75)"
			/>
		</svg>
	);
};

// Phone Icon
export const Phone = ({ fill }: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="26.589"
			height="26.693"
			viewBox="0 0 26.589 26.693"
			fill={fill}
		>
			<defs>
				<clipPath id="clip-path">
					<rect
						id="Rectangle_7765"
						data-name="Rectangle 7765"
						width="26.589"
						height="26.693"
						transform="translate(0 0)"
					/>
				</clipPath>
			</defs>
			<g id="Group_749" data-name="Group 749" transform="translate(0 0)">
				<g id="Group_749-2" data-name="Group 749" clip-path="url(#clip-path)">
					<path
						id="Path_4990"
						data-name="Path 4990"
						d="M25.114,18.456l-7.195-3.2a.8.8,0,0,0-.89.165l-1.989,1.989a15.678,15.678,0,0,1-4.075-2.789,15.678,15.678,0,0,1-2.789-4.075L10.166,8.56a.8.8,0,0,0,.166-.89L7.134.475A.8.8,0,0,0,6.089.065L.616,2.41a.8.8,0,0,0-.486.352,1.184,1.184,0,0,0-.079.354v0l-.039,0a.793.793,0,0,0,.014.255c-.167,2.109.257,9.213,6.61,15.582,6,6.014,12.288,6.676,14.766,6.676a9.5,9.5,0,0,0,1.086-.051.8.8,0,0,0,.637-.479l2.4-5.6a.8.8,0,0,0-.41-1.045M21.85,24.017c-1.7.051-8.074-.173-14.081-6.195A20.056,20.056,0,0,1,1.584,3.735l4.409-1.89L8.648,7.817l-2.01,2.01a.8.8,0,0,0-.149.924,18.3,18.3,0,0,0,3.347,5,18.3,18.3,0,0,0,5,3.347.8.8,0,0,0,.924-.149l2.01-2.01L23.744,19.6Z"
						transform="translate(0.4 0.6)"
					/>
					<path
						id="Path_4991"
						data-name="Path 4991"
						d="M192.924,25.611a9.34,9.34,0,0,1,6.63,2.963,9.335,9.335,0,0,1,2.963,6.63.8.8,0,0,0,1.6,0,10.9,10.9,0,0,0-3.432-7.76,11.046,11.046,0,0,0-7.76-3.432.8.8,0,1,0,0,1.6"
						transform="translate(-178.926 -21.813)"
					/>
					<path
						id="Path_4992"
						data-name="Path 4992"
						d="M192.959,96.012a.8.8,0,0,0,0,1.6,4.663,4.663,0,0,1,4.793,4.8.8.8,0,0,0,1.6,0,6.261,6.261,0,0,0-6.391-6.4Z"
						transform="translate(-178.959 -89.016)"
					/>
				</g>
			</g>
		</svg>
	);
};
